import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "./store";

export type ShowForm = "workExperiences" | "educations" | "projects" | "skills" | "custom";

export interface ResumeSettings {
  theme: {
    fontFamily: string;
    fontSize: string;
    documentSize: string;
    template: string;
  };
  formsOrder: ShowForm[];
}

const initialSettings: ResumeSettings = {
  theme: {
    fontFamily: "Inter",
    fontSize: "12px",
    documentSize: "Letter",
    template: "classic-blue",
  },
  formsOrder: ["workExperiences", "educations", "projects", "skills", "custom"],
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState: initialSettings,
  reducers: {
    changeSettings: (
      draft,
      action: PayloadAction<{
        field: keyof ResumeSettings;
        value: any;
      }>
    ) => {
      const { field, value } = action.payload;
      draft[field] = value;
    },
    changeTheme: (
      draft,
      action: PayloadAction<{
        field: keyof ResumeSettings["theme"];
        value: string;
      }>
    ) => {
      const { field, value } = action.payload;
      draft.theme[field] = value;
    },
    changeFormsOrder: (
      draft,
      action: PayloadAction<{ formsOrder: ShowForm[] }>
    ) => {
      const { formsOrder } = action.payload;
      draft.formsOrder = formsOrder;
    },
  },
});

export const { changeSettings, changeTheme, changeFormsOrder } =
  settingsSlice.actions;

export const selectSettings = (state: RootState) => state.settings;
export const selectTheme = (state: RootState) => state.settings.theme;
export const selectFormsOrder = (state: RootState) => state.settings.formsOrder;

export default settingsSlice.reducer;
